import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import downloadBlob from '../lib/download-blob';
import {
    PROJECT_BUNDLE_EXTENSION,
    createProjectBundle
} from '../lib/project-bundle';
import {getVisionClassifierSession} from '../lib/vision/vision-classifier-session';
import {projectTitleInitialState} from '../reducers/project-title';

class ProjectBundleDownloader extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'downloadProjectBundle'
        ]);
    }

    async downloadProjectBundle () {
        const [projectData, visionTrainingData] = await Promise.all([
            this.props.saveProjectSb3(),
            getVisionClassifierSession(this.props.vm).exportTrainingData()
        ]);

        const bundle = await createProjectBundle({
            projectTitle: this.props.projectTitle,
            projectData,
            visionTrainingData
        });

        if (this.props.onSaveFinished) {
            this.props.onSaveFinished();
        }

        downloadBlob(
            this.props.projectBundleFilename,
            new Blob([bundle], {type: 'application/json'})
        );
    }

    render () {
        return this.props.children(
            this.props.className,
            this.downloadProjectBundle
        );
    }
}

const getProjectBundleFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }

    return `${filenameTitle.substring(0, 100)}${PROJECT_BUNDLE_EXTENSION}`;
};

ProjectBundleDownloader.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    projectBundleFilename: PropTypes.string,
    projectTitle: PropTypes.string,
    saveProjectSb3: PropTypes.func,
    vm: PropTypes.shape({
        saveProjectSb3: PropTypes.func
    })
};

ProjectBundleDownloader.defaultProps = {
    className: ''
};

const mapStateToProps = state => ({
    projectBundleFilename: getProjectBundleFilename(
        state.scratchGui.projectTitle,
        projectTitleInitialState
    ),
    projectTitle: state.scratchGui.projectTitle,
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    vm: state.scratchGui.vm
});

export default connect(
    mapStateToProps,
    () => ({})
)(ProjectBundleDownloader);
